module.exports = __webpack_public_path__ + "static/img/e-logo.a935c8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/e-logo.png
// module id = 5T4Q
// module chunks = 34